import {
  IsBoolean,
  IsIn,
  IsArray,
  ArrayMinSize,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import { NodeActionDto } from './node-action.dto';

export class FinishTaskDto {
  @IsIn(['FinishEvent'])
  type: 'FinishEvent';

  @IsArray()
  @ArrayMinSize(1, { message: 'Обязательное поле' })
  @ValidateNested({ each: true })
  @Type(() => NodeActionDto)
  actions: NodeActionDto[];

  @IsBoolean()
  notifyIntegration: boolean;
}
